/* template */
<template><div class="service-notice"><mpx-view v-for="(item, index) in (notices)" :key="item.index" @tap="goServicePage(item.url)">{{item.title}}</mpx-view></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m49c10132"}'>
  .service-notice
    font-family PingFangSC-Regular
    font-size 12px
    line-height 14px
    padding 16px 0
    color #748AAF
    display flex
    flex-direction column
    align-items center
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m49c10132"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex49c10132%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex49c10132%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m49c10132"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index49c10132/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
